<div class="wrapper flex column">
  @if (loading()) {
    <div>
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="50"
      ></mat-progress-spinner>
    </div>
  }
  @if (!loading()) {
    <div
      class="title"
      style="padding-bottom: 0"
    >
      {{ "API_KEYS.MANAGE_KEYS" | translate }}
    </div>
    <mat-card-subtitle style="padding-left: 20px">
      {{ "API_KEYS.ADD_AND_DELETE_KEYS" | translate }}
    </mat-card-subtitle>
    @if (!apiKeys.length) {
      <div style="margin: auto">
        <div class="title">{{ "API_KEYS.NO_KEYS" | translate }}</div>
        <button
          payee-button
          color="blue-payee"
          class="gen-button"
          [isRoundButton]="false"
          [disabled]="loading()"
          (click)="generateAPIKey()"
        >
          <img
            alt=""
            src="assets/shared/global-images/icons/plus-white.svg"
            width="14px"
            height="14px"
          />
          <span>{{ "API_KEYS.GENERATE_FIRST_KEY" | translate }}</span>
        </button>
      </div>
    }
    <div>
      @for (apiKey of apiKeys; track apiKey.value) {
        <mat-card
          appearance="outlined"
          style="margin: 10px"
        >
          <mat-card-title>
            {{ apiKey.value }}
          </mat-card-title>
          <div style="display: flex">
            <mat-card-actions>
              <div style="display: flex; justify-content: flex-end">
                <button
                  payee-icon-button
                  color="white"
                  class="action-button"
                  [isBorderButton]="true"
                  (click)="copyToClipboard(apiKey.value)"
                >
                  <payee-icon name="copy-blue"></payee-icon>
                </button>
                @if (!apiKey.partner) {
                  <button
                    payee-icon-button
                    color="white"
                    class="action-button"
                    [isBorderButton]="true"
                    (click)="deleteAPIKey(apiKey.value)"
                  >
                    <payee-icon name="trash-red"></payee-icon>
                  </button>
                }
              </div>
            </mat-card-actions>
            <div style="margin-left: auto">
              <mat-card-subtitle style="text-align: right">
                {{ "API_KEYS.CREATED_AT" | translate }}
                {{ apiKey.created_at | date: "yyyy.MM.dd. HH:mm:ss" }}
              </mat-card-subtitle>
              @if (apiKey.partner) {
                <mat-card-subtitle style="text-align: right">
                  {{ "API_KEYS.EXTERNAL_PARTNER_KEY" | translate }}
                </mat-card-subtitle>
              }
            </div>
          </div>
        </mat-card>
      }
    </div>
    @if (apiKeys.length) {
      <button
        payee-icon-button
        class="add-key-fab"
        [disabled]="loading()"
        (click)="generateAPIKey()"
      >
        <img
          alt=""
          src="assets/shared/global-images/icons/plus-white.svg"
          width="14px"
          height="14px"
        />
      </button>
    }
  }
</div>
